import React, { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import './Hero.css';

const Hero = () => {
  const heroRef = useRef(null);
  const videoRef = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const scrollY = window.scrollY;
      const hero = heroRef.current;
      const overlay = hero.querySelector('.hero__overlay');
      const content = hero.querySelector('.hero__content');
      const video = hero.querySelector('.hero__video');

      if (video) {
        video.style.transform = `scale(1.15) translateY(${scrollY * 0.3}px)`;
      }
      if (overlay) {
        overlay.style.opacity = 0.4 + scrollY * 0.001;
      }
      if (content) {
        content.style.transform = `translateY(${scrollY * 0.15}px)`;
        content.style.opacity = 1 - scrollY * 0.002;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseMove = (e) => {
    const { clientX, clientY } = e;
    const x = (clientX / window.innerWidth - 0.5) * 20;
    const y = (clientY / window.innerHeight - 0.5) * 20;
    setMousePos({ x, y });
  };

  const scrollToNext = (e) => {
    e.preventDefault();
    const about = document.querySelector('#about');
    if (about) about.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero" id="hero" ref={heroRef} onMouseMove={handleMouseMove}>
      {/* Video Background */}
      <div className="hero__video-wrapper">
        <video
          ref={videoRef}
          className="hero__video"
          autoPlay
          muted
          loop
          playsInline
          poster="https://images.unsplash.com/photo-1519741497674-611481863552?w=1920&q=80"
          style={{
            transform: `scale(1.15) translate(${mousePos.x * 0.3}px, ${mousePos.y * 0.3}px)`,
          }}
        >
          <source
            src="https://cdn.coverr.co/videos/coverr-wedding-couple-dancing-in-the-dark-with-sparklers-1584/1080p.mp4"
            type="video/mp4"
          />
        </video>
        <div className="hero__overlay" />
        <div className="hero__grain" />
      </div>

      {/* Content */}
      <div className="hero__content">
        <motion.div
          className="hero__label"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5, duration: 0.8 }}
        >
          <span className="hero__label-line" />
          <span>Wedding & Event Planner</span>
          <span className="hero__label-line" />
        </motion.div>

        <motion.h1
          className="hero__title"
          initial={{ opacity: 0, y: 60 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7, duration: 1, ease: [0.16, 1, 0.3, 1] }}
        >
          <span className="hero__title-line">Krijimi i</span>
          <span className="hero__title-line hero__title-line--italic">
            Momenteve
          </span>
          <span className="hero__title-line">
            Magjike<span className="hero__title-dot">.</span>
          </span>
        </motion.h1>

        <motion.p
          className="hero__description"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.0, duration: 0.8 }}
        >
          Transformojm ngjarjet tuaja ne pervoja te paharrueshme.
          <br />
          Dasma, festa, dhe evente qe mbeten pergjithmone.
        </motion.p>

        <motion.div
          className="hero__actions"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1.3, duration: 0.8 }}
        >
          <a href="#contact" className="btn-primary" onClick={(e) => {
            e.preventDefault();
            document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            <span>Rezervo Konsulten</span>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </a>
          <a href="#gallery" className="hero__play-btn" onClick={(e) => {
            e.preventDefault();
            document.querySelector('#gallery')?.scrollIntoView({ behavior: 'smooth' });
          }}>
            <div className="hero__play-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <polygon points="5,3 19,12 5,21" />
              </svg>
            </div>
            <span>Shiko Punet Tona</span>
          </a>
        </motion.div>

        {/* Stats */}
        <motion.div
          className="hero__stats"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.6, duration: 1 }}
        >
          {[
            { number: '500+', label: 'Evente' },
            { number: '8+', label: 'Vite Pervoje' },
            { number: '100%', label: 'Kenaqesi' },
          ].map((stat, i) => (
            <div className="hero__stat" key={i}>
              <span className="hero__stat-number">{stat.number}</span>
              <span className="hero__stat-label">{stat.label}</span>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        className="hero__scroll"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1 }}
        onClick={scrollToNext}
      >
        <div className="hero__scroll-line" />
        <span>Scroll</span>
      </motion.div>

      {/* Side decoration */}
      <div className="hero__side-text">
        <span>Paradise Events</span>
        <span className="hero__side-divider" />
        <span>Pristina, Kosovo</span>
      </div>
    </section>
  );
};

export default Hero;
